module.exports = __webpack_public_path__ + "static/images/arrow-down.1SCyDtq.svg";